import React from "react";
import { i18n } from "../../../services/i18nService";
import { FrameIcon, Text, withFocusable } from "../../../services/visualLibraryService";
import { AccountDetailsWrapper, ButtonAccountDetailStyled, HeaderTextStyled } from "../../Settings/styles/Styled";
import { withAppState } from "../../../state";
import { routes } from "../../../routes";
import { Profile } from "./Profile";

const ButtonFocus = withFocusable(ButtonAccountDetailStyled);

const defaultFocusPath = "btn_selector_0";
export const AccountDetails = withAppState(props => {
  const { history } = props.parentProps;
  const { userAccount } = props;
  return !userAccount ? (
    <>
      <AccountDetailsWrapper>
        <FrameIcon name="profile" alignSelf="start" />
        <HeaderTextStyled rank="1" text={i18n.get(`global.editProfile.signup.title`)} size="large" />
        <Text rank="1" text={i18n.get(`global.prompt.signup.subTitle`)} size="small" type="greyLight" />
      </AccountDetailsWrapper>
      <ButtonFocus
        label={i18n.get(`global.editProfile.signup.signupCta`).toUpperCase()}
        focusPath={defaultFocusPath}
        onEnterPress={() => {
          history.push({
            pathname: routes.pinSignup,
            state: {
              ...history.location.state,
              backDestination: routes.settings
            }
          });
        }}
        onClick={() => {
          history.push({
            pathname: routes.pinSignup,
            state: {
              ...history.location.state,
              backDestination: routes.settings
            }
          });
        }}
        size="medium"
        spacing="small"
        displayBlock={true}
        //onRef={ref => ("")}
        dataSnDown={""}
        dataSnUp={""}
        dataSnLeft={i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT ? `@btn_selector_1` : ""}
        dataSnRight={i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT ? `@secondaryItem_0` : `@btn_selector_1`}
      />
      <ButtonFocus
        label={i18n.get(`pages.settings.accountStatus.login`).toUpperCase()}
        focusPath="btn_selector_1"
        onEnterPress={() => {
          history.push({
            pathname: routes.pin,
            state: {
              ...history.location.state,
              backDestination: routes.settings
            }
          });
        }}
        onClick = {() => {
          history.push({
            pathname: routes.pin,
            state: {
              ...history.location.state,
              backDestination: routes.settings
            }
          });
        }}
        size="medium"
        spacing="small"
        displayBlock={true}
        dataSnDown={""}
        dataSnUp={""}
        dataSnLeft={`@btn_selector_0`}
      />
    </>
  ) : (
    <Profile userAccount={userAccount} />
  );
});

export default AccountDetails;
